import { CSS_VAR_STYLE_EL_ID, FONT_STYLE_EL_ID, PREVIEW_CLASSNAME } from '../../../constants/GlobalStyles';
import { GROUP, VARIANT_SELECT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
export const loadStyleTag = (id, content = '') => {
  let styleEl = document.getElementById(id);
  if (styleEl) {
    styleEl.textContent = content;
  } else {
    styleEl = document.createElement('style');
    styleEl.setAttribute('id', id);
    styleEl.textContent = content;
    const head = document.querySelector('head');
    head === null || head === void 0 || head.appendChild(styleEl);
  }
};
export const loadCssVars = css => {
  if (css.indexOf(':root') === -1) {
    return;
  }
  const cssStringWithClassname = css.replace(/:root/g, `.${PREVIEW_CLASSNAME}`);
  loadStyleTag(CSS_VAR_STYLE_EL_ID, cssStringWithClassname);
};
export const loadFontStyles = fontStyles => {
  loadStyleTag(FONT_STYLE_EL_ID, fontStyles);
};
export const removeAllGlobalStyles = () => {
  const cssVarStyleEl = document.getElementById(CSS_VAR_STYLE_EL_ID);
  cssVarStyleEl === null || cssVarStyleEl === void 0 || cssVarStyleEl.remove();
  const fontStyleEl = document.getElementById(FONT_STYLE_EL_ID);
  fontStyleEl === null || fontStyleEl === void 0 || fontStyleEl.remove();
};
export const shouldLoadGlobalStyles = fields => {
  return fields.some(field => {
    if (field.type === VARIANT_SELECT) return true;
    if (field.type === GROUP && field.children) return shouldLoadGlobalStyles(field.children);
    return false;
  });
};